import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import store from '@/store/index';
import * as serviceWorker from './serviceWorker';
import 'antd-mobile/dist/antd-mobile.css';
import '@/assets/css/index.scss';
import Routers from '@/router/index';
import FirstScreen from '@/views/FirstScreen/index';
import { getLocalCdnLink } from '@/utils/cdn';

// ($localCdnLink)设置图片CDN跟目录 - 目前有南非和墨西哥服务
// todo 后期可做成与页面一直 挂载在路由文件上
getLocalCdnLink();

function listen () {
  if (document.readyState === 'complete') { // 资源加载完成
    ReactDOM.render(
      <Provider store={store}>
        <React.StrictMode>
          <Routers/>
        </React.StrictMode>
      </Provider>,
      document.getElementById('root')
    );
  } else { // 资源加载中
    if(['tifi.com.mx', 'www.tifi.com.mx', 'tifi.co.ke', 'www.tifi.co.ke'].includes(window.location.host) || window.location.href.includes('tifi')) return

    ReactDOM.render(
      <Router>
        <Route path="/" component={FirstScreen} />
      </Router>,
      document.getElementById('root')
    )
  }
}

document.onreadystatechange = listen

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
